import { render, staticRenderFns } from "./assign_worker.vue?vue&type=template&id=44642950&scoped=true"
import script from "./assign_worker.vue?vue&type=script&lang=js"
export * from "./assign_worker.vue?vue&type=script&lang=js"
import style0 from "./assign_worker.vue?vue&type=style&index=0&id=44642950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44642950",
  null
  
)

export default component.exports